import { PLAN_DATA_RECEIVED, PLAN_DATA_UNLOAD } from './types'
import api from 'api'

export const planDataReceived = data => ({
  type: PLAN_DATA_RECEIVED,
  data
})

export const planDataUnload = () => ({
  type: PLAN_DATA_UNLOAD
})

export const savePlan = plan => dispatch =>
  api.bmc.plans.savePlan(plan).then( data => {
    sessionStorage.setItem('planId', data.id)
    dispatch(planDataReceived(data))
  })

export const unloadPlan = () => dispatch => {
  sessionStorage.removeItem('planId')
  dispatch(planDataUnload())
}

export const getPlanData = id => dispatch =>
  api.bmc.plans.getPlanData(id).then( data => {
    sessionStorage.setItem('planId', data.id)
    dispatch(planDataReceived(data))
  })